import { formatDateTime } from "../../../users/adminUserFormatters";

const WeatherRadarHealthActions = ({
  canManage = false,
  lastRefreshedAt,
  refreshing,
  runningAction,
  pipelineBusy,
  onRefresh,
  onCopyDiagnostics,
  onExportDiagnostics,
  onOpenLatestFrame,
  onOpenSiataLatestFrame,
  onRunDiscovery,
  onSyncCache,
  onCleanupStale,
  onSiataDiscovery,
  onSiataSync,
  onSiataCleanup,
  onAerocivilDiscovery,
  onAerocivilSync,
  onOpenAerocivilLatestFrame,
  siataEnabled = false,
  aerocivilEnabled = false,
}) => {
  const actionDisabled = Boolean(runningAction) || pipelineBusy;

  return (
    <div className="weather-radar-health-actions panel-card">
      <div className="weather-radar-health-actions__header">
        <h2 className="admin-section-title">Radar health actions</h2>
        {lastRefreshedAt ? (
          <p className="weather-radar-health-actions__meta">
            Last refreshed {formatDateTime(lastRefreshedAt)}
          </p>
        ) : null}
      </div>

      <div className="weather-radar-health-actions__buttons">
        <button
          type="button"
          className="admin-dashboard__action-btn"
          onClick={onRefresh}
          disabled={refreshing || actionDisabled}
        >
          {refreshing ? "Refreshing…" : "Refresh health"}
        </button>
        <button
          type="button"
          className="admin-dashboard__action-btn"
          onClick={onCopyDiagnostics}
          disabled={actionDisabled}
        >
          Copy diagnostics
        </button>
        <button
          type="button"
          className="admin-dashboard__action-btn"
          onClick={onExportDiagnostics}
          disabled={actionDisabled}
        >
          Export diagnostics
        </button>
        <button
          type="button"
          className="admin-dashboard__action-btn"
          onClick={onOpenLatestFrame}
          disabled={actionDisabled}
        >
          Open latest BART frame
        </button>
        {siataEnabled ? (
          <button
            type="button"
            className="admin-dashboard__action-btn"
            onClick={onOpenSiataLatestFrame}
            disabled={actionDisabled}
          >
            Preview SIATA latest frame
          </button>
        ) : null}
        {aerocivilEnabled ? (
          <button
            type="button"
            className="admin-dashboard__action-btn"
            onClick={onOpenAerocivilLatestFrame}
            disabled={actionDisabled}
          >
            Preview Aerocivil latest frame
          </button>
        ) : null}

        {canManage ? (
          <>
            <button
              type="button"
              className="admin-dashboard__action-btn"
              onClick={onRunDiscovery}
              disabled={actionDisabled}
            >
              {runningAction === "bart_discovery" ? "Running discovery…" : "Run discovery"}
            </button>
            <button
              type="button"
              className="admin-dashboard__action-btn"
              onClick={onSyncCache}
              disabled={actionDisabled}
            >
              {runningAction === "bart_cache_sync" ? "Syncing cache…" : "Sync cache"}
            </button>
            <button
              type="button"
              className="admin-dashboard__action-btn"
              onClick={onCleanupStale}
              disabled={actionDisabled}
            >
              {runningAction === "bart_cache_cleanup" ? "Cleaning cache…" : "Clear stale BART frames"}
            </button>
            {siataEnabled ? (
              <>
                <button
                  type="button"
                  className="admin-dashboard__action-btn"
                  onClick={onSiataDiscovery}
                  disabled={actionDisabled}
                >
                  {runningAction === "siata_radar_discover" ? "Running SIATA discovery…" : "SIATA discover"}
                </button>
                <button
                  type="button"
                  className="admin-dashboard__action-btn"
                  onClick={onSiataSync}
                  disabled={actionDisabled}
                >
                  {runningAction === "siata_radar_sync" ? "Syncing SIATA cache…" : "SIATA sync cache"}
                </button>
                <button
                  type="button"
                  className="admin-dashboard__action-btn"
                  onClick={onSiataCleanup}
                  disabled={actionDisabled}
                >
                  {runningAction === "siata_radar_cleanup"
                    ? "Cleaning SIATA cache…"
                    : "SIATA cleanup stale"}
                </button>
              </>
            ) : null}
            {aerocivilEnabled ? (
              <>
                <button
                  type="button"
                  className="admin-dashboard__action-btn"
                  onClick={onAerocivilDiscovery}
                  disabled={actionDisabled}
                >
                  {runningAction === "aerocivil_radar_discover"
                    ? "Running Aerocivil discovery…"
                    : "Aerocivil discover"}
                </button>
                <button
                  type="button"
                  className="admin-dashboard__action-btn"
                  onClick={onAerocivilSync}
                  disabled={actionDisabled}
                >
                  {runningAction === "aerocivil_radar_sync"
                    ? "Syncing Aerocivil cache…"
                    : "Aerocivil sync cache"}
                </button>
              </>
            ) : null}
          </>
        ) : null}
      </div>

      {!canManage ? (
        <p className="weather-radar-health-actions__hint">
          Discovery, sync, and cleanup require weather layer manage permission.
        </p>
      ) : null}
    </div>
  );
};

export default WeatherRadarHealthActions;
